import './styles.scss'
import React from 'react'
import ComingSoonPopUp from 'Components/UIComponent/ComingSoonPopUp'

const CoffeeCart = () => (
  <div>
    <ComingSoonPopUp />
  </div>
)

export default CoffeeCart
